import {UserService} from "../utils/users";
import Api from "../services/api";
import * as logger from "../utils/logger";
import { UserUpdater } from "../utils/userUpdater";
import { SecurityService } from "../utils/security";
import { DriveStore } from "../store/reducers";

export class UserSync {
    private readonly debounceWaitMs = 3000;
    private readonly userTimeOutDictionary: IIdDictionary<number>;
    private readonly userUpdater: UserUpdater;
    constructor(
        private readonly userService: UserService,
        private readonly securityService: SecurityService,
        private readonly api: Api,
        private readonly store: DriveStore
    ) {
        this.userTimeOutDictionary = {};
        this.userUpdater = new UserUpdater(this.api, this.userService, this.securityService, this.store);
    }

    syncUserDebounced(userId: string) {
        this.userTimeOutDictionary[userId] && clearTimeout(this.userTimeOutDictionary[userId]);
        this.userTimeOutDictionary[userId] = setTimeout(() => this.fetchUser(userId), this.debounceWaitMs);
    }

    fetchUser(userId: string, forceGetPermissions = true, forceGetUserData = false) {
        const userInStorage = this.userService.getUserById(userId);
        if (userInStorage) {
            this.userUpdater.updateUser(userInStorage.name.toLowerCase(), undefined, forceGetPermissions, forceGetUserData)
                .catch(err => logger.error(logger.Source.SYNC, `Couldn't get the user ${ userId } ${ err.message }`, this.api.getUser(), err));
        }
    }
}